const toggle = document.querySelector('.vp-header .open-menu')

if (toggle) {
    toggle.addEventListener('click', () => {
        document.body.classList.toggle('menu-open')
    })

    // close menu when clicking outside
    document.addEventListener('click', (e) => {
        if (
            document.body.classList.contains('menu-open') &&
            !e.target.closest('.vp-header .open-menu') &&
            !e.target.closest('.vp-header #menu-header')
        )
            document.body.classList.remove('menu-open')
    })
}
